<app-splash-screen id="app-splash-screen"></app-splash-screen>
<router-outlet></router-outlet>
<div class="d-none">Version : {{ version }}</div>
<div class="d-none">Build number : {{ buildNumber }}</div>